/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";


import TerminalsListTerminalComponent from "@UIPages/Authenticated/Terminals/List/Terminals/Terminal";


import TERMINAL_INTERFACE from "@Services/Application/Interfaces/Terminals/Terminal";


type TerminalsListProps = {
    TERMINALS: TERMINAL_INTERFACE[];
    TERMINALS_LIST_TYPE?: "TERMINALS" | "FAVORITE_TERMINALS" | "DISPOSITIONS" | "MONITORY_NOTES";
    FAVORITE?: boolean;
    SHOW_ALL_PETROL_BASES_STATUS?: boolean;
};


export const TerminalsListComponent: React.FC<TerminalsListProps> = ({
    TERMINALS, TERMINALS_LIST_TYPE = "TERMINALS", FAVORITE = false,
    SHOW_ALL_PETROL_BASES_STATUS = true
}): JSX.Element | null => {


    if (!TERMINALS || !SHOW_ALL_PETROL_BASES_STATUS) return null;


    const TerminalsList = TERMINALS.map((TERMINAL: TERMINAL_INTERFACE, i: number) =>
        <TerminalsListTerminalComponent
            key={i}
            TERMINAL={TERMINAL}
            TERMINALS_LIST_TYPE={TERMINALS_LIST_TYPE}
        />
    );


    return (
        <Col xs={12} className={"terminals-list-component terminals-list content-items-list-component content-items-list"}>
            <Row className={"terminals-list-content"}>

                <Col xs={12} className={"terminals-list-header content-items-list-header"}>
                    <span>{FAVORITE ? "Ulubione" : "Pozostałe"}</span>
                </Col>

                {TERMINALS.length < 1 ?
                <Col xs={12} className={"no-list-elements-message default-system-message"}>
                    <span>{FAVORITE ? "Brak ulubionych baz paliw" : "Brak baz paliw"}</span>
                </Col>
                :
                TerminalsList
                }

            </Row>
        </Col>
    );

};


export default TerminalsListComponent;
